<template>
  <div class="ni-detail">
    <template v-if="entry.kind === 'request'">
      <div class="ni-detail__section">
        <div class="ni-detail__header">
          <span class="ni-detail__label">Запрос</span>
          <button class="ni-detail__copy" @click="copy(formatJson(entry.sentPayload))">скопировать</button>
        </div>
        <pre class="ni-detail__json">{{ formatJson(entry.sentPayload) }}</pre>
      </div>
      <div class="ni-detail__section">
        <div class="ni-detail__header">
          <span class="ni-detail__label" :class="{ 'ni-detail__label--error': entry.status === 'error' }">
            {{ entry.status === 'error' ? 'Ошибка' : 'Ответ' }}
          </span>
          <button
            v-if="entry.responsePayload !== null"
            class="ni-detail__copy"
            @click="copy(formatJson(entry.responsePayload))"
          >скопировать</button>
        </div>
        <pre v-if="entry.status === 'error'" class="ni-detail__json ni-detail__json--error">{{ entry.error }}</pre>
        <pre v-else class="ni-detail__json">{{ formatJson(entry.responsePayload) }}</pre>
      </div>
    </template>

    <template v-else>
      <div class="ni-detail__section">
        <div class="ni-detail__header">
          <span class="ni-detail__label">Данные</span>
          <button class="ni-detail__copy" @click="copy(formatJson(entry.receivedPayload))">скопировать</button>
        </div>
        <pre class="ni-detail__json">{{ formatJson(entry.receivedPayload) }}</pre>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { NatsTraceEntry } from './types'

defineProps<{ entry: NatsTraceEntry }>()

const formatJson = (data: unknown): string => {
  try {
    return JSON.stringify(data, null, 2)
  } catch {
    return String(data)
  }
}

const copy = (text: string) => {
  navigator.clipboard.writeText(text).catch((err) => console.warn('Clipboard write failed:', err))
}
</script>

<style scoped>
.ni-detail {
  display: flex;
  gap: 8px;
  padding: 8px 12px 12px;
  background: #161616;
  border-top: 1px solid #333;
}

.ni-detail__section {
  flex: 1;
  min-width: 0;
}

.ni-detail__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.ni-detail__label {
  font-size: 11px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ni-detail__label--error {
  color: #e55;
}

.ni-detail__copy {
  background: none;
  border: 1px solid #444;
  color: #aaa;
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 3px;
  cursor: pointer;
}

.ni-detail__copy:hover {
  border-color: #888;
  color: #ddd;
}

.ni-detail__json {
  margin: 0;
  padding: 8px;
  background: #111;
  border: 1px solid #333;
  border-radius: 4px;
  color: #ccc;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 300px;
  overflow-y: auto;
}

.ni-detail__json--error {
  color: #e55;
}
</style>
